<div class="position-relative z-3" (clickOutside)="hideContent()">
  <a
    type="button"
    class="app-selection-trigger d-flex justify-content-center p-2 pt-0 position-relative"
    (click)="toggleContent()"
    ngbTooltip="Open app selection"
    placement="left"
    [openDelay]="1000"
    data-cy="app-selection"
  >
    <span class="rb-ic rb-ic-grid-view fs-2xl hover-effect"></span>
  </a>
  <div
    *ngIf="isContentVisible"
    class="app-selection-panel p-3 rounded-2 position-absolute end-0 border"
  >
    <div
      class="app-selection-cell"
      *hasPermissionAny="[Permissions.RCS_Apps_Rc_Access, Permissions.RCS_Apps_All]"
    >
      <a
        class="app-selection-item d-flex flex-column align-items-center justify-content-center ho-menu-item p-2 rounded-2 text-reset"
        routerLink="/road-condition"
        routerLinkActive="sel-menu-item"
        [routerLinkActiveOptions]="{ exact: false }"
        data-cy="roadConditionView"
      >
        <span class="rb-ic rb-ic-weather-cloud-sun-rain-snow fs-2xl"></span>
        <span class="fs-xs text-center text-decoration-none">Road Condition</span>
      </a>
    </div>
    <div
      class="app-selection-cell"
      *hasPermissionAny="[Permissions.RCS_Apps_Bwc_Access, Permissions.RCS_Apps_All]"
    >
      <a
        class="app-selection-item d-flex flex-column align-items-center justify-content-center ho-menu-item p-2 rounded-2 text-reset"
        routerLink="/bad-weather-condition"
        routerLinkActive="sel-menu-item"
        [routerLinkActiveOptions]="{ exact: false }"
        data-cy="badWeatherConditionView"
      >
        <span class="rb-ic rb-ic-weather-cloud-sun-rain-snow fs-2xl"></span>
        <span class="fs-xs text-center text-decoration-none">BWC</span>
      </a>
    </div>
    <div
      class="app-selection-cell"
      *hasPermissionAny="[Permissions.RCS_Apps_Mobile_Access, Permissions.RCS_Apps_All]"
    >
      <a
        class="app-selection-item d-flex flex-column align-items-center justify-content-center ho-menu-item p-2 rounded-2 text-reset"
        routerLink="/mobile"
        routerLinkActive="sel-menu-item"
        [routerLinkActiveOptions]="{ exact: false }"
        data-cy="mobileView"
      >
        <span class="rb-ic rb-ic-car-smartphone-locator fs-2xl"></span>
        <span class="fs-xs text-center text-decoration-none">Mobile View</span>
      </a>
    </div>
    <div
      class="app-selection-cell"
      *hasPermissionAny="[Permissions.RCS_Apps_Obstacle_Access, Permissions.RCS_Apps_All]"
    >
      <a
        class="app-selection-item d-flex flex-column align-items-center justify-content-center ho-menu-item p-2 rounded-2 text-reset"
        routerLink="/obstacle"
        routerLinkActive="sel-menu-item"
        [routerLinkActiveOptions]="{ exact: false }"
        data-cy="obstacleView"
      >
        <span class="rb-ic rb-ic-traffic-cone fs-2xl"></span>
        <span class="fs-xs text-center text-decoration-none">Obstacle</span>
      </a>
    </div>
    <div
      class="app-selection-cell"
      *hasPermissionAny="[Permissions.RCS_Apps_Customer_Access, Permissions.RCS_Apps_All]"
    >
      <a
        class="app-selection-item d-flex flex-column align-items-center justify-content-center ho-menu-item p-2 rounded-2 text-reset"
        routerLink="/customer"
        routerLinkActive="sel-menu-item"
        [routerLinkActiveOptions]="{ exact: false }"
        data-cy="customerView"
      >
        <span class="rb-ic rb-ic-customer fs-2xl"></span>
        <span class="fs-xs text-center text-decoration-none">Customer</span>
      </a>
    </div>
    <div
      class="app-selection-cell"
      *hasPermissionAny="[Permissions.RCS_Apps_Simulation_Access, Permissions.RCS_Apps_All]"
    >
      <a
        class="app-selection-item d-flex flex-column align-items-center justify-content-center ho-menu-item p-2 rounded-2 text-reset"
        routerLink="/simulation"
        routerLinkActive="sel-menu-item"
        [routerLinkActiveOptions]="{ exact: false }"
        data-cy="simulationView"
      >
        <span class="rb-ic rb-ic-plan-floorplan-edit fs-2xl"></span>
        <span class="fs-xs text-center text-decoration-none">Simulation</span>
      </a>
    </div>
  </div>
</div>
